import { type ReactNode, useState } from "react";

export default function Lazy({
  children,
  label = "Fetch",
}: {
  children: ReactNode;
  label?: string;
}) {
  const [show, setShow] = useState(false);

  if (!show)
    return (
      <button type="button" onClick={() => setShow(true)}>
        {label}
      </button>
    );

  return <>{children}</>;
}
